import {Route} from '@angular/router';
import {PreviewLayoutComponent} from '@shared/components/layouts/preview-layout/preview-layout.component';
import { PreviewContextService } from '@app/features/preview/core/services/preview-context.service';

export const previewRoute : Route[]= [
  {
    path : ':region/:landId',
    component : PreviewLayoutComponent,
    providers: [PreviewContextService],
    children : [
      {
        path: 'hbu',
        loadComponent: () => import('@app/features/preview/pages/hbu-study/hbu-study.component')
      },
      {
        path: 'demographic',
        loadComponent: () => import('@app/features/preview/pages/preview-demographic/preview-demographic.component')
      },
      {
        path: 'financial',
        loadComponent: () => import('@app/features/preview/pages/preview-financial/preview-financial.component')
      },
      {
        path: 'market',
        loadComponent: () => import('@app/features/preview/pages/preview-demographic/preview-demographic.component')
      },
      {
        path: 'macro',
        loadComponent: () => import('@app/features/preview/pages/preview-macro/preview-macro.component')
      },
      {
        path: 'geospatial-regulations',
        loadComponent: () => import('@app/features/preview/pages/preview-geospatial-regulations/preview-geospatial-regulations.component')
      },
      {
        path: 'infrastructure-sustainability',
        loadComponent: () => import('@app/features/preview/pages/preview-infrastructure-sustainability/preview-infrastructure-sustainability.component')
      },
      {
        path: 'demand/:subSectionId',
        loadComponent: () => import('@app/features/preview/pages/demand-analysis-preview/demand-analysis-preview.component')
      }, 
      {
        path: 'supply/:subSectionId',
        loadComponent: () => import('@app/features/preview/pages/supply-analysis-preview/supply-analysis-preview.component')
      }
    ]
  }
]
